import * as React from 'react';

function SvgNumberIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect opacity={0.15} width={28} height={28} rx={3} fill="#232340" />
      <path
        d="M20.125 11.32H17.35a.145.145 0 01-.14-.108.146.146 0 01-.003-.063l.573-3.144a.728.728 0 10-1.434-.262l-.63 3.457a.147.147 0 01-.144.12h-2.12a.145.145 0 01-.14-.109.147.147 0 01-.003-.063l.573-3.144a.729.729 0 00-1.434-.262l-.63 3.458a.146.146 0 01-.144.12H8.99a.73.73 0 100 1.458h2.364a.147.147 0 01.112.055.143.143 0 01.031.12l-.391 2.145a.145.145 0 01-.144.12H7.875a.729.729 0 100 1.458h2.77a.145.145 0 01.143.17l-.573 3.144a.73.73 0 001.434.262l.63-3.459a.147.147 0 01.144-.117h2.12a.145.145 0 01.14.11c.006.02.006.041.003.062l-.574 3.145a.729.729 0 001.435.262l.63-3.46a.146.146 0 01.144-.116h2.69a.73.73 0 000-1.458H16.64a.147.147 0 01-.141-.109.146.146 0 01-.003-.063l.392-2.147a.145.145 0 01.143-.12h3.092a.729.729 0 100-1.458l.002-.003zm-5.12 3.778a.146.146 0 01-.144.12h-2.12a.146.146 0 01-.143-.172l.392-2.147a.147.147 0 01.143-.12h2.12a.145.145 0 01.143.172l-.391 2.147z"
        fill="#232340"
      />
    </svg>
  );
}

export default SvgNumberIcon;
